/**
 * HOW AN HTTP FAILURE CARRIES THE CALLER'S OPTIONAL CONTEXT -- the label a caller names its request by
 * (`'JWKS fetch failed'`): as the message head, and as the error's `details`. The fetch transport, the response-JSON
 * readers (`tools/http/`) and the body parser (`utils/http/`) each spelled both ternaries; const-homed so the `utils/`
 * reader can bind it (`QUAL-NO-RUNTIME-IMPORTS-IN-UTILS-001`) and an empty label reads as no label everywhere.
 */

/** The error `details` for `context`: `{ context }` when one was named, else no details at all.
 *  @runtime-derived-ssot-helper (const-leaf-pinned): read by `tools/http/` and `utils/http/` alike. */
export function httpErrorContextDetails(context: string | undefined): { context: string } | undefined {
	return context ? { context } : undefined;
}

/** The message head for `context`: `<context>: ` when one was named, else nothing.
 *  @runtime-derived-ssot-helper (const-leaf-pinned): the message half of the same decision. */
export function httpErrorContextPrefix(context: string | undefined): string {
	return context ? `${context}: ` : '';
}
